import { Component } from 'react'
import { connect } from 'react-redux'

import './index.scss'

import ImageChrome from '../../asserts/browser/chrome.png'
import ImageFirefox from '../../asserts/browser/firefox.png'
import ImageSafari from '../../asserts/browser/safari.png'
import ImageEdge from '../../asserts/browser/edge.png'

class Tip extends Component {
  render () {
    let { lang } = this.props
    return (
      <div className='page-tip'>
        <div className='tip-container'>
          <div className='tip-title'>{lang === 'cn' ? '您当前浏览器的版本过低' : 'Your current browser version is too low'}</div>
          <div className='tip-text'>{lang === 'cn' ? '为了获得更友好的浏览体验，请升级到最新版' : 'In order to get a more friendly browsing experience, please upgrade to the latest version'}</div>
          <div className='tip-text'>{lang === 'cn' ? '或者使用以下主流浏览器：' : 'Or use the following mainstream browsers:'}</div>
          <div className='browser-list'>
            <div className='browser-item'>
              <img className='browser-image' src={ImageChrome} alt='Chrome'/>
              <div className='browser-title'>Chrome</div>
            </div>
            <div className='browser-item'>
              <img className='browser-image' src={ImageFirefox} alt='Firefox'/>
              <div className='browser-title'>Firefox</div>
            </div>
            <div className='browser-item'>
              <img className='browser-image' src={ImageSafari} alt='Safari'/>
              <div className='browser-title'>Safari</div>
            </div>
            <div className='browser-item'>
              <img className='browser-image' src={ImageEdge} alt='Microsoft Edge'/>
              <div className='browser-title'>Microsoft Edge</div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    lang: state.app.lang
  }
}

export default connect(mapStateToProps)(Tip)